module.exports = __webpack_public_path__ + "img/partner.c0cefcf5.png";